import { PureLightTheme } from '../../../styles/theme'
import { COLORS } from '../../../styles/variables'

export const legalPageSx = {
  maxWidth: 760,
  margin: '0 auto',
  paddingBottom: '48px',
  [PureLightTheme.breakpoints.down('lg')]: {
    padding: '0 30px 72px 30px',
  },
}

export const legalTitleSx = {
  margin: '0 0 8px 0',
  textAlign: 'center',
}

export const legalMetaSx = {
  textAlign: 'center',
  color: COLORS.SMOKEY_GREY,
  marginBottom: 3,
}

export const legalSectionSx = {
  marginTop: 3,
}

export const legalSectionTitleSx = {
  marginBottom: 1.5,
}

export const legalSubsectionTitleSx = {
  marginTop: 2,
  marginBottom: 1,
  fontSize: '1rem',
  fontWeight: 600,
}

export const legalParagraphSx = {
  color: COLORS.CHARCOAL_GREY,
  marginBottom: 1.5,
  '&:last-child': {
    marginBottom: 0,
  },
}

export const legalBulletListSx = {
  margin: '0 0 1.5rem 0',
  paddingLeft: 2.5,
  color: COLORS.CHARCOAL_GREY,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
}

export const legalRelatedLinksSx = {
  marginTop: 4,
  paddingTop: 2,
  borderTop: `1px solid ${COLORS.CATSKILL_WHITE}`,
}

export const legalRelatedLinksTitleSx = {
  marginBottom: 1,
  fontWeight: 600,
}

export const legalRelatedLinksListSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1.5,
}
